export const BRAND_ID = '871B96D7-FC9D-46F1-9807-BF5C3A77890B';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

